import { ClockCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import Link from 'next/link'
import BASE_CONFIG from 'src/configs/base'
import { convertImagePath } from 'src/utils/common'

const PostNews = ({ data }) => {
	return (
		<div className="c-post__news-wrapper">
			<Link
				href={`/tin-tuc/${data.CategorySlug}/${data.SEO.Slug || BASE_CONFIG.DEFAULT_SEO_SLUG}/${
					data.Id
				}`}
			>
					<h2 className="info-title--mb">{data.Name}</h2>
			</Link>
			<div className="c-post__news">
				<div className="post__news-container">
					<div className="post__news-thumbnail">
						<Link
							href={`/tin-tuc/${data.CategorySlug}/${
								data.SEO.Slug || BASE_CONFIG.DEFAULT_SEO_SLUG
							}/${data.Id}`}
						>
						
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img src={convertImagePath(data.Thumb)} alt={data.Name?? "247Express-Nhanh hơn bạn nghĩ"} />
						
						</Link>
					</div>
					<div className="post__news-info">
						<Link
							href={`/tin-tuc/${data.CategorySlug}/${
								data.SEO.Slug || BASE_CONFIG.DEFAULT_SEO_SLUG
							}/${data.Id}`}
						>
							
								<h2 className="info-title">{data.Name}</h2>

						</Link>
						<p className="info-description">{data.Summary}</p>
						<span className="info-timestamp">
							<ClockCircleOutlined
								style={{ marginRight: 10, transform: 'translateY(-3px)', fontSize: 16 }}
							/>
							<span className="timestamp-text">
								{moment(data.CreatedDate).format('DD/MM/YYYY')}
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PostNews
